import styles from './toast.module.css';

function Toast({ message, duration, type = 'default' }) {
    const typeClass = {
        default: styles.toastDefault,
        success: styles.toastSuccess,
        error: styles.toastError
    }[type] || styles.toastDefault;

    return (
        <div className={`${styles.toast} ${typeClass}`}>
            <span>{message}</span>
            <div
                className={styles.progress}
                style={{ animationDuration: `${duration}ms` }}
            />
        </div>
    );
}

export default Toast;